var codeblock_default = {
  "blockStyleSpacing": "O2J66",
  "codeBlock": "SnBRQ O2J66",
  "renderedInTable": "sP4LK"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
